import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsOpencollectiveComponent } from './simple-icons-opencollective.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsOpencollectiveComponent ],
    exports:      [ SimpleIconsOpencollectiveComponent ],
    bootstrap:    []
})
export class SimpleIconsOpencollectiveModule {}
